import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  pageForm: {
    textAlign: 'center'
  },
  resetPageSuccessIcon: {
    marginBottom: '40px',
    '& svg': {
      fontSize: '72px'
    },
    '& path': {
      fill: palette.success.main
    }
  }
});
export default useStyles;